module.exports = __webpack_public_path__ + "img/play.0a3e3e8f.svg";